import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './App.css';

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="yuppy-app">
      <header className="header">
        <div className="container header-container">
          <div className="logo">
            <Link to="/">
              <img src={require('./assets/images/fixed-logo-1024.png')} alt="Yuppy Logo" className="logo-img" />
              yuppy
            </Link>
          </div>
          <nav className="navigation">
            <ul>
              <li><Link to="/">Home</Link></li>
            </ul>
          </nav>
        </div>
      </header>
      <div style={{ maxWidth: 700, margin: '100px auto 60px auto', padding: '32px', background: '#fff', borderRadius: 16, boxShadow: '0 2px 16px rgba(0,0,0,0.07)' }}>
        <h1>Yuppy Privacy Policy</h1>
        <p><strong>Effective Date:</strong> June 30, 2025</p>
        <p><strong>Last Updated:</strong> July 27, 2025</p>
        
        <p>At Yuppy ("we," "our," or "us"), your privacy is our priority. This Privacy Policy explains how we collect, use, and protect your information when you access our mobile application, website, and related services (collectively, the "Services").</p>
        
        <h2>1. Information We Collect</h2>
        <h3>Account Information</h3>
        <ul>
          <li>Email address, username, and optional profile photo</li>
        </ul>
        
        <h3>User Content</h3>
        <ul>
          <li>Photos, captions, likes, comments, and leaderboard activity</li>
          <li>Metadata associated with uploaded photos (e.g., timestamp, file details)</li>
          <li>Location data associated with photos (optional, if provided)</li>
        </ul>
        <p>By posting photos, captions, or other content to Yuppy, you grant us a limited license to display, reproduce, and share that content within the app, on our social media channels, and in promotional materials for the purpose of showcasing user activity and promoting the community.</p>
        
        <h3>Device & Usage Data</h3>
        <ul>
          <li>Device type, operating system, browser type</li>
          <li>IP address, language settings, crash logs, and in-app behavior</li>
          <li>Collected via analytics tools to help improve app performance</li>
        </ul>
        
        <h3>Waitlist & Communication</h3>
        <ul>
          <li>Email and other information voluntarily submitted via the website or app</li>
        </ul>
        
        <h2>2. How We Use Your Information</h2>
        <p>We use the information we collect to:</p>
        <ul>
          <li>Operate and maintain the Yuppy platform</li>
          <li>Display user-generated content (photos, likes, comments, profiles)</li>
          <li>Feature publicly shared user content (such as photos or captions) on our website, social media pages, or promotional materials to highlight community activity and engagement</li>
          <li>Analyze trends and improve functionality</li>
          <li>Respond to support requests and communicate important updates</li>
          <li>Send promotional or onboarding communications (you can opt out)</li>
          <li>Comply with legal and regulatory requirements</li>
        </ul>
        
        <h2>3. Sharing Your Information</h2>
        <p>We do not sell your personal information.</p>
        <p>We may share your information with trusted third-party service providers to support and operate our Services. These include:</p>
        <ul>
          <li>Supabase (for backend infrastructure and user authentication)</li>
          <li>Cloud hosting and storage providers</li>
          <li>Analytics platforms (e.g., Firebase, Google Analytics)</li>
          <li>Email and communication tools (for waitlist and notifications)</li>
        </ul>
        <p>All providers are required to handle your information securely and in compliance with relevant laws.</p>
        
        <h2>4. Your Rights & Choices</h2>
        <p>You have the right to:</p>
        <ul>
          <li>View and edit your profile within the app</li>
          <li>Request deletion of your account or personal data by contacting us at yuppy.nyc.team@gmail.com</li>
          <li>Opt out of non-essential communications</li>
          <li>Manage photo location permissions via your device settings</li>
        </ul>
        
        <h2>5. Cookies & Tracking Technologies</h2>
        <p>Our website may use cookies or similar technologies to enhance functionality and understand user behavior. You can manage cookie preferences through your browser settings.</p>
        
        <h2>6. Children's Privacy</h2>
        <p>Yuppy is not intended for users under the age of 13. We do not knowingly collect personal information from children. If we discover such information, it will be deleted promptly.</p>
        
        <h2>7. Data Security</h2>
        <p>We implement reasonable administrative, technical, and physical safeguards to protect your information. While we implement industry-standard security measures, no method of transmission or storage is entirely immune to risk.</p>
        
        <h2>8. Changes to This Privacy Policy</h2>
        <p>We may update this Privacy Policy from time to time. Changes will be posted within the app or on our website with a new effective date. We may also notify you via email or in-app notifications when appropriate.</p>
        
        <h2>9. Contact Us</h2>
        <p>If you have any questions, concerns, or requests related to your privacy, please contact us at:</p>
        <p>📧 yuppy.nyc.team@gmail.com</p>
      </div>
    </div>
  );
} 